import { useSession } from '@/contexts/session-context';

export interface CurrentRole {
  role: 'admin' | 'member' | null;
  orgId: string | null;
  isLoading: boolean;
}

export function useCurrentRole(): CurrentRole {
  const { isLoading, role, organizationId } = useSession();

  if (isLoading) {
    return { role: null, orgId: null, isLoading: true };
  }

  const jwtRole = role === 'admin' || role === 'member' ? role : null;
  return { role: jwtRole, orgId: organizationId ?? null, isLoading: false };
}
